import { radioCategories, countries } from '@/mocks/registerRadio';
import type { RadioFormData } from '../types';

interface RadioDataFormProps {
  formData: RadioFormData;
  updateField: (field: keyof RadioFormData, value: string) => void;
  errors: Record<string, string>;
}

export default function RadioDataForm({ formData, updateField, errors }: RadioDataFormProps) {
  return (
    <div className="space-y-5">
      <div>
        <label className="block text-xs font-semibold text-foreground-700 mb-1.5">
          Nombre de la radio <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          value={formData.name}
          onChange={(e) => updateField('name', e.target.value)}
          placeholder="Ej: Radio Estrella"
          maxLength={80}
          className={`w-full px-3.5 py-2.5 rounded-xl border text-sm text-foreground-900 placeholder:text-foreground-300 focus:outline-none focus:ring-2 transition-all ${
            errors.name
              ? 'border-red-300 bg-red-50/30 focus:ring-red-400/60 focus:border-red-400'
              : 'border-background-200 bg-background-50 focus:ring-primary-400/60 focus:border-primary-400'
          }`}
        />
        {errors.name && <p className="text-[11px] text-red-500 mt-1">{errors.name}</p>}
      </div>

      <div>
        <label className="block text-xs font-semibold text-foreground-700 mb-1.5">
          Eslogan
        </label>
        <input
          type="text"
          value={formData.slogan}
          onChange={(e) => updateField('slogan', e.target.value)}
          placeholder="Ej: La que suena diferente"
          maxLength={120}
          className="w-full px-3.5 py-2.5 rounded-xl border border-background-200 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-300 focus:outline-none focus:ring-2 focus:ring-primary-400/60 focus:border-primary-400 transition-all"
        />
      </div>

      <div>
        <label className="block text-xs font-semibold text-foreground-700 mb-1.5">
          Descripción
        </label>
        <textarea
          value={formData.description}
          onChange={(e) => updateField('description', e.target.value)}
          placeholder="Cuéntanos de qué trata tu radio..."
          maxLength={500}
          rows={3}
          className="w-full px-3.5 py-2.5 rounded-xl border border-background-200 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-300 focus:outline-none focus:ring-2 focus:ring-primary-400/60 focus:border-primary-400 transition-all resize-none"
        ></textarea>
        <p className="text-[10px] text-foreground-400 mt-1 text-right">
          {formData.description.length}/500
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className="block text-xs font-semibold text-foreground-700 mb-1.5">
            Categoría <span className="text-red-500">*</span>
          </label>
          <select
            value={formData.category}
            onChange={(e) => updateField('category', e.target.value)}
            className={`w-full px-3.5 py-2.5 rounded-xl border text-sm text-foreground-900 focus:outline-none focus:ring-2 transition-all appearance-none bg-background-50 ${
              errors.category
                ? 'border-red-300 bg-red-50/30 focus:ring-red-400/60 focus:border-red-400'
                : 'border-background-200 focus:ring-primary-400/60 focus:border-primary-400'
            }`}
          >
            <option value="">Selecciona una categoría</option>
            {radioCategories.map((cat) => (
              <option key={cat} value={cat}>{cat}</option>
            ))}
          </select>
          {errors.category && <p className="text-[11px] text-red-500 mt-1">{errors.category}</p>}
        </div>

        <div>
          <label className="block text-xs font-semibold text-foreground-700 mb-1.5">
            País <span className="text-red-500">*</span>
          </label>
          <select
            value={formData.country}
            onChange={(e) => updateField('country', e.target.value)}
            className={`w-full px-3.5 py-2.5 rounded-xl border text-sm text-foreground-900 focus:outline-none focus:ring-2 transition-all appearance-none bg-background-50 ${
              errors.country
                ? 'border-red-300 bg-red-50/30 focus:ring-red-400/60 focus:border-red-400'
                : 'border-background-200 focus:ring-primary-400/60 focus:border-primary-400'
            }`}
          >
            <option value="">Selecciona un país</option>
            {countries.map((c) => (
              <option key={c} value={c}>{c}</option>
            ))}
          </select>
          {errors.country && <p className="text-[11px] text-red-500 mt-1">{errors.country}</p>}
        </div>
      </div>

      <div>
        <label className="block text-xs font-semibold text-foreground-700 mb-1.5">
          Ciudad
        </label>
        <input
          type="text"
          value={formData.city}
          onChange={(e) => updateField('city', e.target.value)}
          placeholder="Ej: Buenos Aires"
          maxLength={60}
          className="w-full px-3.5 py-2.5 rounded-xl border border-background-200 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-300 focus:outline-none focus:ring-2 focus:ring-primary-400/60 focus:border-primary-400 transition-all"
        />
      </div>
    </div>
  );
}